import { useState } from 'react';

const testimonials = [
  {
    quote: "DJ Bugsie absolutely made our wedding. He read the crowd perfectly — from the ceremony to the last dance, every song was exactly right. Our guests are still talking about it months later!",
    name: "Sarah M.",
    event: "Wedding Reception",
  },
  {
    quote: "We hired Bugsie Productions for our company holiday party and it was the best decision we made. The DJ kept everyone on the dance floor all night and the photo booth was a huge hit.",
    name: "James T.",
    event: "Corporate Holiday Party",
  },
  {
    quote: "Our school prom was incredible thanks to Bugsie. The music was perfect, the emcee kept the energy insane, and the setup looked so professional. Every student loved it.",
    name: "Michelle R.",
    event: "High School Prom",
  },
  {
    quote: "The karaoke setup was top-notch and the DJ kept the party going between sets. Everyone had an absolute blast. Bugsie Productions is the real deal — highly recommend!",
    name: "David K.",
    event: "Private Birthday Party",
  },
  {
    quote: "From our first call to the last song, Bugsie was professional, responsive, and genuinely fun to work with. He made our wedding reception feel like a concert. 10/10.",
    name: "Amanda L.",
    event: "Wedding",
  },
  {
    quote: "We've booked Bugsie Productions for three consecutive corporate events. Every single time they deliver — great music, great energy, and a team that truly cares about your event.",
    name: "Robert H.",
    event: "Corporate Event",
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#080808] py-28 md:py-36 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_50%,_#D4AF3705_0%,_transparent_70%)] pointer-events-none"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="w-10 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-semibold">Client Reviews</span>
            <div className="w-10 h-px bg-[#D4AF37]"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            What Clients Say
          </h2>
          <div className="flex items-center justify-center gap-1.5">
            {[1,2,3,4,5].map(i => (
              <div key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-[#D4AF37] text-base"></i>
              </div>
            ))}
            <span className="text-white font-bold ml-2 text-sm">5.0</span>
            <span className="text-gray-600 text-sm ml-1">· 140+ Reviews on WeddingWire &amp; Yelp</span>
          </div>
        </div>

        {/* Staggered grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
          {testimonials.slice(0, 3).map((t, i) => (
            <div
              key={i}
              onClick={() => setActive(i)}
              className={`relative bg-[#0F0F0F] border rounded-2xl p-7 cursor-pointer transition-all duration-400 ${
                active === i
                  ? 'border-[#D4AF37]/50 bg-[#111111]'
                  : 'border-white/6 hover:border-white/15'
              } ${i === 1 ? 'md:mt-6' : ''}`}
            >
              {active === i && (
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/60 to-transparent rounded-t-2xl"></div>
              )}
              <div className="text-[#D4AF37]/20 text-7xl font-serif leading-none mb-3 select-none">&ldquo;</div>
              <p className="text-gray-300 text-sm leading-relaxed mb-6 italic">{t.quote}</p>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-white font-semibold text-sm">{t.name}</div>
                  <div className="text-[#D4AF37] text-xs tracking-widest uppercase mt-0.5">{t.event}</div>
                </div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(s => (
                    <div key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[#D4AF37] text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {testimonials.slice(3).map((t, i) => (
            <div
              key={i}
              className={`bg-[#0F0F0F] border border-white/6 hover:border-white/15 rounded-2xl p-7 transition-all duration-400 cursor-default ${i === 1 ? 'md:-mt-4' : ''}`}
            >
              <div className="text-[#D4AF37]/20 text-7xl font-serif leading-none mb-3 select-none">&ldquo;</div>
              <p className="text-gray-300 text-sm leading-relaxed mb-6 italic">{t.quote}</p>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-white font-semibold text-sm">{t.name}</div>
                  <div className="text-[#D4AF37] text-xs tracking-widest uppercase mt-0.5">{t.event}</div>
                </div>
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(s => (
                    <div key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-[#D4AF37] text-xs"></i>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
            className="inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#c49d2a] text-black font-bold px-12 py-4 rounded-full text-sm tracking-widest uppercase transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Book Your DJ
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
